import { AxiosResponse } from 'axios'

export interface IPagination {
  isLast: boolean
  limit: number
  nextOffset: number
  nextPage: number
  offset: number
  page: number
  total: number
  totalPages: number
}

export interface IRequestPagination {
  limit: IPagination['limit']
  offset: IPagination['offset']
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IResponsePagination extends IPagination {}

export interface IResponse<T> {
  data: T
  pagination?: IResponsePagination
}

export interface IResponseError<T> {
  errorCode: string
  errorDescription?: string
  errorInvalidFields?: T[]
  statusCode: number
  timestamp: string
  sentryErrorId?: string
}

export type WrappedResponse<T> = AxiosResponse<IResponse<T>>

export interface IResponseSuccess {
  success: boolean
}

export enum FilterVariantE {
  LIKE = 'like',
  IN = 'in',
  EQUAL = 'equal',
}

export interface IFilter<FilterPropertyNamesT> {
  id: FilterPropertyNamesT
  value: string | (string | null)[]
  filterVariant?: FilterVariantE
  isDate?: boolean
}

export type FilterT<FilterPropertyNamesT> = IFilter<FilterPropertyNamesT>[] | null

export interface ISort<SortPropertyNamesT> {
  propertyName: SortPropertyNamesT
  sortType: 'asc' | 'desc'
}

export type SortT<SortPropertyNamesT> = ISort<SortPropertyNamesT> | null

export interface IBasePayload<FilterPropertyNamesT = any, SortPropertyNamesT = any> {
  filters?: IFilter<FilterPropertyNamesT>[] | null
  sort?: ISort<SortPropertyNamesT> | null
  pagination: IRequestPagination
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IBaseGetRequest<FilterPropertyNamesT = any, SortPropertyNamesT = any>
  extends IBasePayload<FilterPropertyNamesT, SortPropertyNamesT> {}

export enum ContractTypeE {
  ERC721 = 'ERC721',
  ERC1155 = 'ERC1155',
}

export enum ContractStatusE {
  PENDING = 'pending',
  DEPLOYING = 'deploying',
  DEPLOYED = 'deployed',
}

export interface IBaseContract {
  id: string
  name: string
  address: string
  tx: string | null
  type: ContractTypeE
  status: ContractStatusE
  createdAt: string
  updatedAt: string
}
